export default {
  itemStyle: {
    normal: {
      color: '#c23531',
      color0: '#314656',
      borderColor: '#c23531',
      borderColor0: '#314656',
      borderWidth: 1
    }
  }
};